import * as API from "middleware/api";
import { readTransaction as readCoreTransaction } from "middleware/form";

export const massEcheqManagePreRequest = () => API.executeWithAccessToken("/mass.echeq.manage.pre");

export const massEcheqManageListRequest = (filters) => API.executeWithAccessToken("/mass.echeq.manage.list", filters);

export const massEcheqManagePreviewRequest = (massEcheqManageData) =>
    API.executeWithAccessToken("/mass.echeq.manage.preview", massEcheqManageData);

export const massEcheqManageDetailRequest = (filters) =>
    API.executeWithAccessToken("/mass.echeq.manage.detail", filters);

export const massEcheqManageBatchDownloadRequest = (idBatch) =>
    API.executeWithAccessToken("/mass.echeq.manage.batch.download", {
        idBatch,
    });

export const massEcheqManageSendRequest = (activityPath, payload) => API.executeWithAccessToken(activityPath, payload);

export const massEcheqManageReadTransactionRequest = (idTransaction) => readCoreTransaction(idTransaction);
